export default __webpack_public_path__ + "static/media/004-B-mesureDeProtection.2eb575cf.svg";